import { ElementType } from '@src/interfaces/elements';
import { uuid } from '@src/utils';
export default (name) => {
    const newId = uuid();
    return {
        id: newId,
        name: name,
        type: ElementType.New,
        root: null,
        modifiers: {},
    };
};
